import { useSSO } from 'config';
import {
  LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, LOGIN_STEP, LOGOUT_REQUEST, LOGOUT_SUCCESS, LOGOUT_FAILURE,
  LOGIN_VALIDATION_ERRORS, INITIALIZE_LOGIN, NOT_AUTHENTICATED, AUTHENTICATED,
  SSO_CHECK_START, SSO_CHECK_END, SET_DETAIL_IDS, SET_SECURITY_CODE,
} from '../constants/ActionTypes';

export default function loginReducer(state = {
  isAuthenticated: false, ssoLoading: false, user: {}, securityCode: null,
}, action) {
  switch (action.type) {
    case SSO_CHECK_START:
      return {
        ...state,
        ssoLoading: true,
      };
    case SSO_CHECK_END:
      return {
        ...state,
        ssoLoading: false,
      };
    case LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        isAuthenticated: false,
        credentials: action.credentials,
        validationErrors: null,
        error: null,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        user: action.user,
        securityCode: null,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        error: action.error,
        validationError: {},
        ssoLoading: false,
        securityCode: null,
      };
    case LOGOUT_REQUEST:
      return {
        ...state,
        loading: true,
        error: {},
        validationError: {},
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        user: {},
        step: useSSO ? 'sso' : 'initial',
      };
    case LOGOUT_FAILURE:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        user: {},
        error: action.error,
        step: useSSO ? 'sso' : 'initial',
      };
    case LOGIN_STEP:
      return {
        ...state,
        step: action.step,
        validationErrors: [],
        error: null,
      };
    case LOGIN_VALIDATION_ERRORS:
      return {
        ...state,
        validationError: action.validationError,
      };
    case INITIALIZE_LOGIN:
      return {
        ...state,
        validationErrors: [],
      };
    case NOT_AUTHENTICATED:
      return {
        ...state,
        isAuthenticated: false,
        user: {},
      };
    case AUTHENTICATED:
      return {
        ...state,
        isAuthenticated: true,
        user: action.user,
      };
    case SET_DETAIL_IDS:
      return {
        ...state,
        user: {
          ...state.user,
          detailIDs: action.detailIDs.map(x => x.EmployeeDetailID),
        },
      };
    case SET_SECURITY_CODE:
      return {
        ...state,
        securityCode: action.securityCode,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/loginReducer.js